import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=5945063c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5945063c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5945063c')) {
      api.createRecord('5945063c', component.options)
    } else {
      api.reload('5945063c', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=5945063c&scoped=true", function () {
      api.rerender('5945063c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/Main.vue"
export default component.exports